/**
 * The support contact, in one place.
 *
 * KinCode has a single human-reachable address, used for organisation and
 * over-limit enquiries, and — added in Phase 8 — as the fallback contact shown by
 * the footer and the client error boundary when something has gone wrong. It lived
 * as a literal inside the pricing page; centralising it means the address changes
 * in one edit and every surface stays consistent.
 *
 * This is a display value, not a secret: it is meant to appear on the page.
 */

/** The address KinCode users write to. */
export const SUPPORT_EMAIL = "kincode@drmsite.com";

/**
 * A `mailto:` link, optionally with a pre-filled subject. Handled natively by the
 * browser, never by the router.
 *
 * @param {string} [subject] A subject line to pre-fill; omitted for a bare mailto.
 * @returns {string}
 */
export function supportHref(subject) {
  if (subject === undefined) {
    return `mailto:${SUPPORT_EMAIL}`;
  }
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
